import { render } from "./TestExpenseHead.vue?vue&type=template&id=2661b652&scoped=true"
import script from "./TestExpenseHead.vue?vue&type=script&lang=js"
export * from "./TestExpenseHead.vue?vue&type=script&lang=js"

import "./TestExpenseHead.vue?vue&type=style&index=0&id=2661b652&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2661b652"]])

export default __exports__